/** @jsxImportSource @emotion/react */
import React, { FC, PropsWithChildren } from 'react';
import { Container } from '@mui/material';

const Layout: FC<PropsWithChildren> = (props) => {
  return <Container maxWidth="sm" {...props} />;
};

export default Layout;
